var map = {
	"./annotation.svg": 51277,
	"./arrowLeft.svg": 14228,
	"./avatar.svg": 68328,
	"./burger.svg": 74501,
	"./calendar.svg": 35952,
	"./celebrationIcon.svg": 62596,
	"./checkCircle.svg": 11742,
	"./chevronDown.svg": 4052,
	"./clipboardCopy.svg": 52595,
	"./collection.svg": 27024,
	"./collection1.svg": 21839,
	"./cross.svg": 63344,
	"./documentDuplicate.svg": 89535,
	"./dotsHorizontal.svg": 61152,
	"./elipsesHorizontal.svg": 90301,
	"./exclamationCircle.svg": 84971,
	"./eye.svg": 53660,
	"./folder.svg": 40451,
	"./menu.svg": 35124,
	"./messageSquare.svg": 20760,
	"./moon.svg": 40613,
	"./officeBuilding.svg": 24201,
	"./pencil.svg": 22656,
	"./pencilAlt.svg": 15236,
	"./plus1.svg": 32050,
	"./plus2.svg": 90016,
	"./plusIcon.svg": 85966,
	"./search.svg": 75850,
	"./sortAscending.svg": 58874,
	"./sun.svg": 86542,
	"./tag.svg": 51868,
	"./userGroup.svg": 16975,
	"theme/images/annotation.svg": 51277,
	"theme/images/arrowLeft.svg": 14228,
	"theme/images/avatar.svg": 68328,
	"theme/images/burger.svg": 74501,
	"theme/images/calendar.svg": 35952,
	"theme/images/celebrationIcon.svg": 62596,
	"theme/images/checkCircle.svg": 11742,
	"theme/images/chevronDown.svg": 4052,
	"theme/images/clipboardCopy.svg": 52595,
	"theme/images/collection.svg": 27024,
	"theme/images/collection1.svg": 21839,
	"theme/images/cross.svg": 63344,
	"theme/images/documentDuplicate.svg": 89535,
	"theme/images/dotsHorizontal.svg": 61152,
	"theme/images/elipsesHorizontal.svg": 90301,
	"theme/images/exclamationCircle.svg": 84971,
	"theme/images/eye.svg": 53660,
	"theme/images/folder.svg": 40451,
	"theme/images/menu.svg": 35124,
	"theme/images/messageSquare.svg": 20760,
	"theme/images/moon.svg": 40613,
	"theme/images/officeBuilding.svg": 24201,
	"theme/images/pencil.svg": 22656,
	"theme/images/pencilAlt.svg": 15236,
	"theme/images/plus1.svg": 32050,
	"theme/images/plus2.svg": 90016,
	"theme/images/plusIcon.svg": 85966,
	"theme/images/search.svg": 75850,
	"theme/images/sortAscending.svg": 58874,
	"theme/images/sun.svg": 86542,
	"theme/images/tag.svg": 51868,
	"theme/images/userGroup.svg": 16975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71937;